<template>
  <cx-dropdown trigger="click, hover" :keepDropdownAfterClick="multiple" transition="cv-slidedown" >
    <div class="cx-field m-searchform__input -round-corner">
      <i v-if="icon" :class="icon"></i>
      <template v-if="prefix && selectedOption">
        {{prefix}}
      </template>
      {{selectedOptionName}}
    </div>
    <template slot="content">
      <ul class="cx-list cx-list--vertical"
        :aria-activedescendant="lastSelection ? `${name}-${lastSelection}` : false">
        <li v-if="showAny" class="cx-list__item">
          <span class="cx-link cx-link--xs"
            :id="`${name}-${ANY}`" 
            role="option"
            :class="{'-active': isSelected(ANY)}"
            tabindex="0"
            @keypress.enter="$event.target.click()"
            @click.prevent="updateSelectedOption(ANY);$emit('change', ANY)">
            {{defaultOptionName || $t('common.any')}}
            <span class="cx-link__icon" v-show="isSelected(ANY)">
              <i class="fal fa-check"></i>
            </span>
          </span>
        </li>
        <li v-for="o in options" :key="o.value" 
          class="cx-list__item">
          <span class="cx-link cx-link--xs" 
            :id="`${name}-${o.value}`" 
            role="option"
            :class="{'-active': isSelected(o.value)}"
            tabindex="0"
            @keypress.enter="$event.target.click()"
            @click.prevent="updateSelectedOption(o.value);$emit('change', o.value)">
            {{o.name}}
            <span class="cx-link__icon" v-show="isSelected(o.value)">
              <i class="fal fa-check"></i>
            </span>
          </span>
        </li>
      </ul>
    </template>
  </cx-dropdown>
</template>

<script>
export default {
  name: 'rich-search-select',
  uit() {
    return [
      ['common', ['any']]
    ]
  },
  props: {
    defaultOptionName: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'Option',
    },
    showAny: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => []
    },
    prefix: {
      type: String,
      default: ''
    },
    selectedOption: {
      type: String,
      default: '',
    },
    preset: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ANY: '',
      BREAKER: ',',
      lastSelection: null
    }
  },
  computed: {
    selectedOptionName: function() {
      if (this.multiple) {
        return (this.options 
          // && Array.isArray(this.options)
          && this.options
              .filter(o => this.isSelected(o.value))
              .map(o => o.name)
              .join(', ')) || this.name;
      } else {
        let option = this.options
          // && Array.isArray(this.options)
          && this.options.find(o => o.value == this.selectedOption) || { name: this.name };
        return option.name;
      }
    },
    processSelectedOption: function() {
      return this.multiple 
        ? this.selectedOption.split(this.BREAKER)
        : this.selectedOption;
    }
  },
  methods: {
    isSelected: function(v) {
      return this.multiple
        ? this.processSelectedOption.includes(v)
        : this.processSelectedOption == v
    },
    updateSelectedOption: function(v) {
      this.lastSelection = v;
      let value = v;
      if (this.multiple && v != this.ANY && this.selectedOption != this.ANY) {
        value = this.isSelected(v)
          ? this.processSelectedOption.filter(o => o != v).join(this.BREAKER)
          : this.selectedOption + this.BREAKER + v;
      }

      this.$emit('update:selectedOption', value);
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function() {
        if (this.multiple) {
          this.updateSelectedOption(
            (this.options 
              // && Array.isArray(this.options)
              && this.processSelectedOption
                  .filter(v => this.options.find(o => o.value == v))
                  .join(this.BREAKER)
            ) || this.ANY
          )
        } else {
          this.updateSelectedOption((this.options 
            // && Array.isArray(this.options)
            && this.options.find(o => o.value == this.selectedOption)
          ) ? this.selectedOption : this.ANY);
        }
      },
    },
    preset: {
      immediate: true,
      handler: function(val) {
        if (this.multiple) {
          val = val.split(this.BREAKER);
          this.updateSelectedOption(
            (this.options 
              && Array.isArray(this.options)
              && val
                  .filter(v => this.options.find(o => o.value == v))
                  .join(this.BREAKER)
            ) || this.ANY
          )
        } else {
          this.updateSelectedOption((this.options 
            && Array.isArray(this.options)
            && this.options.find(o => o.value == val)
          ) ? val : '');
        }
      }
    },
  }
}
</script>